var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSofa = function SvgSofa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M7 2.5h6A3.5 3.5 0 0 1 16.5 6v.55c-1.141.231-2 1.24-2 2.45a14 14 0 0 0 .055 1.014C13.225 9.656 11.657 9.5 10 9.5c-1.658 0-3.226.156-4.556.514l.01-.093c.03-.372.046-.758.046-.921 0-1.21-.859-2.219-2-2.45V6a3.5 3.5 0 0 1 3.32-3.495z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M17 6.5A2.5 2.5 0 0 1 19.5 9a2.49 2.49 0 0 1-1 1.995V13a2.5 2.5 0 0 1-2.5 2.5H4A2.5 2.5 0 0 1 1.5 13v-2.005A2.49 2.49 0 0 1 .5 9a2.5 2.5 0 0 1 5 0c0 .163-.017.549-.047.92q-.004.048-.009.094C6.774 9.656 8.342 9.5 10 9.5s3.225.156 4.555.514A16 16 0 0 1 14.5 9 2.5 2.5 0 0 1 17 6.5ZM6.5 17a.5.5 0 0 1-.5.5h-.5A.5.5 0 0 1 5 17v-1.5h1.5zM15 17a.5.5 0 0 1-.5.5H14a.5.5 0 0 1-.5-.5v-1.5H15z"
  })));
};
export default SvgSofa;